// src/CircularProgressBar.js
import React, { useState } from "react";
import "./custom.css";

const CircularProgressBar = () => {
  // Define the values for the progress bars
  const [values, setValues] = useState([60, 30, 90]);

  return (
    <div className="circular-progress-container">
      {values.map((value, index) => (
        <div key={index} className="circular-progress">
          <div className="circular-progress-inner">
            <div className="circular-progress-left">
              <div className="circular-progress-half"></div>
            </div>
            <div className="circular-progress-right">
              <div
                className="circular-progress-half"
                style={{ transform: `rotate(${(value / 100) * 360}deg)` }}
              ></div>
            </div>
          </div>
          <div className="circular-progress-label">{value}%</div>
        </div>
      ))}
    </div>
  );
};

export default CircularProgressBar;
